var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 7.5C11.3594 7.76522 11.254 8.01957 11.0665 8.20711C10.8789 8.39464 10.6246 8.5 10.3594 8.5H4.35938L2.35938 10.5V2.5C2.35938 2.23478 2.46473 1.98043 2.65227 1.79289C2.8398 1.60536 3.09416 1.5 3.35938 1.5H10.3594C10.6246 1.5 10.8789 1.60536 11.0665 1.79289C11.254 1.98043 11.3594 2.23478 11.3594 2.5V7.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.427ebed53081cfe8c38514332f09de5b.svg";
export { ForwardRef as ReactComponent };